import { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';

/** The thread a link opens on, by the identifier of its answer. */
export const LinkedThreadContext = createContext<string | null>(null);

export const useLinkedThreadHere = () => useContext(LinkedThreadContext);

/** Read from the address of the e-mail button that named the thread; a page opened any other way has none. */
export const useLinkedThreadId = () =>
    useParams<{ linkedThreadId?: string }>().linkedThreadId ?? null;
